export default __webpack_public_path__ + "static/CLDA_Logo-23fb3381326f628d06c5fc08b148b85f.png";